<div class="maps-container" style="z-index: 1">
    @if (!isMapLoading) {

      <google-map
        width="100%" 
        [height]="height" 
        [options]="mapOptions"
        [center]="initialCenter"
        (mapClick)="closeInfoWindow()"
        (mapInitialized)="onMapReady()"> 
  
          <map-marker 
              *ngFor="let loc of markers; trackBy: trackByLocationId" 
              [position]="{ lat: loc.lat, lng: loc.lng }"
              [options]="getMarkerOptions(0)"
              (mapClick)="onMarkerClick(loc)">
          </map-marker>
  
          <map-info-window (closeclick)="closeInfoWindow()" [options]="infoWindowOptions">
              <div *ngIf="selectedMarker" class="iw-container">
                  <div class="iw-image-wrapper">
                      <app-save-button 
                        [propertyId]="selectedMarker.property.id"
                        [isLiked]="selectedMarker.property.liked"
                        (likedChange)="selectedMarker.property.liked = $event"></app-save-button>
                      <img [src]="selectedMarker.imageUrl" (click)="openProperty(selectedMarker.id)" class="iw-hero-image" alt="property main image">
                  </div>
                  <div class="iw-details">
                      <h3 style="margin-top: 0.3rem; margin-bottom: 0.3rem;">{{ selectedMarker.name }}</h3>
                      <div class="iw-details-info">
                        <span class="info">
                          {{ selectedMarker.property?.bedrooms }} bedrooms • {{ selectedMarker.property.bathrooms }} bathrooms
                        </span>
                        <span class="cost">
                          {{ selectedMarker.property.cost | currency:'USD' }}
                        </span>
                      </div>
                      <div class="iw-button-wrapper">
                          <button mat-flat-button class="metallic-text-btn-blue" (click)="openProperty(selectedMarker.id)">View Details</button>
                      </div>
                  </div>
              </div>
          </map-info-window>
      </google-map>
    } @else {
      <app-loader></app-loader>
    }
</div>